import React from 'react'
import CircularProgress from '@mui/material/CircularProgress';

function Button({name, onClick, bool, disabled, isLoading}) {
  return (
    <>
    <button 
      className={bool ?' bg-primary-color w-full flex justify-center items-center gap-2 px-4 py-2 border-none rounded-lg font-bold text-white': ' bg-primary-color flex justify-center items-center gap-2 px-4 py-2 border-none rounded-lg font-bold text-white'}
      onClick={onClick}
      type='submit' 
      disabled={disabled || isLoading}
      style={{ opacity: disabled || isLoading ? 0.5 : 1, cursor: disabled || isLoading ? 'not-allowed' : 'pointer' }}
     >
      {isLoading && <CircularProgress size={20} color="inherit" />}
      {name}
     </button>   
    </>
  )
}

export default Button